export const ColumnsConfig = {
    TIME_BALANCE_ONLY: "TIME_BALANCE_ONLY",
    OVERTIME_ONLY: "OVERTIME_ONLY",
    TIME_BALANCE_AND_OVERTIME: "TIME_BALANCE_AND_OVERTIME"
};


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/ColumnsConfig.js